import type { SVGProps } from "react";
import CombustionIcon from "@/components/icons/CombustionIcon";
import { CirclePower, LucideIcon } from "lucide-react";
import ElectricityIcon from "@/components/icons/ElectricityIcon";

export interface MenuItem {
  name: string;
  href: string;
  icon: LucideIcon | SVGProps<SVGSVGElement> | null;
  roles?: string[];
}

export const coefficientsNavigation: MenuItem[] = [
  {
    name: "menu.combustion",
    href: "/coefficients/combustion",
    icon: CombustionIcon as any,
    roles: ["admin"],
  },
  {
    name: "menu.emission",
    href: "/coefficients/emission",
    icon: CirclePower,
    roles: ["admin"],
  },
  {
    name: "menu.consumption",
    href: "/coefficients/consumption",
    icon: CirclePower,
    roles: ["admin"],
  },
  {
    name: "menu.electricity",
    href: "/coefficients/electricity",
    icon: ElectricityIcon as any,
    roles: ["admin"],
  },
];
